import DashboardComponent from './dashboard.component';
import { messagesReducer, AllMessagesComponent } from './messages';
import { RequestAppointmentContainerComponent } from './appointments';

export {
  DashboardComponent,
  messagesReducer,
  AllMessagesComponent,
  RequestAppointmentContainerComponent,
}



// WEBPACK FOOTER //
// src/dashboard/index.js